export class FileConst {
    public static headerTableWithOCR = [
        {
            field: 'type', title: 'Tipo', cell: (row) => ``, class: (row) => {
                switch (row.type) {
                    case 'Image': return `icon-photo`; break;
                    case 'PDF': return `icon-attachment`; break;
                    case 'Word': return `icon-text_format`; break;
                    case 'Excel': return `icon-grid_on`; break;
                    default: return `icon-folder`;
                }
            }
        },
        { field: 'note', title: 'Nombre', cell: (row) => `${row.note}`, class: (row) => `` },
        { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString() + " - " + new Date(row.date).toLocaleTimeString()}`, class: (row) => `` },
        {
            field: 'size', title: 'Tamaño', cell: (row) => {
                const result = parseFloat(row.size) / 1048576;
                const result2 = result.toFixed(2);
                return result2 + ' Mb';
            }, class: (row) => ``
        },
        {
            field: 'tipoGasto', title: 'Tipo Gasto', cell: (row) => {
                return row.tipoGasto;
            }, class: (row) => ``
        },
        {
            field: 'ocrStatusText', title: 'Gasto Generado (OCR)', cell: (row) => {
                switch (row.type) {
                    case 'Directory': return ``; break;
                    default: return `${row.ocrStatusText}`; break;
                }
            }, class: (row) => ``
        },
    ];

    public static headerTableWithoutOCR = [
        {
            field: 'type', title: 'Tipo', cell: (row) => ``, class: (row) => {
                switch (row.type) {
                    case 'Image': return `icon-photo`; break;
                    case 'PDF': return `icon-attachment`; break;
                    case 'Word': return `icon-text_format`; break;
                    case 'Excel': return `icon-grid_on`; break;
                    default: return `icon-folder`;
                }
            }
        },
        { field: 'note', title: 'Nombre', cell: (row) => `${row.note}`, class: (row) => `` },
        { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString() + " - " + new Date(row.date).toLocaleTimeString()}`, class: (row) => `` },
        {
            field: 'size', title: 'Tamaño', cell: (row) => {
                const result = parseFloat(row.size) / 1048576;
                const result2 = result.toFixed(2);
                return result2 + ' Mb';
            }, class: (row) => ``
        },
        {
            field: 'tipoGasto', title: 'Tipo Gasto', cell: (row) => {
                return row.tipoGasto;
            }, class: (row) => ``
        }
    ];
}
